import { IDocumentInfo } from '.';
import { DynamicFormInputType, FormInputTypes } from '@components/_old/dynamicForm';
import { FileType } from '@models/file';
import { CDN_URL } from '@utils';

export const ALLOWED_EXTENSIONS = [FileType.xls, FileType.xlsx];

export const initialValues: IDocumentInfo = {
  documentName: '',
  document: {
    id: '',
    location: '',
    path: '',
    fileName: '',
    length: undefined,
    contentType: '',
  },
};

export const inputs = (
  lineExternalCode: string
): Record<string, DynamicFormInputType> => ({
  document: {
    name: 'document',
    title: 'List of Vehicles',
    type: FormInputTypes.fileuploader,
    value: null,
    required: true,
    disabled: false,
    maxFileSizeInMB: 200,
    allowedFileTypes: ALLOWED_EXTENSIONS,
    imageUrl: '',
    downloadLinks: [
      {
        downloadUrl:
          lineExternalCode === '51'
            ? CDN_URL +
              '/files/line51-vehicle-template/List of Vehicles Template.xlsx'
            : lineExternalCode === '50'
              ? CDN_URL +
                '/files/line50-vehicle-template/List of Vehicles Template.xlsx'
              : CDN_URL +
                '/files/dafault-vehicle-template/List of Vehicles Template.xlsx',
        displayName: 'Download Template',
      },
    ],
  },
});
